import { AreaModel } from '@/models/config'
import { AreaService } from '@/services/config'
import { ref, Ref, computed } from '@vue/composition-api'

export default function useArea () {
  const areas: Ref<AreaModel[]> = ref([])
  const loadingAreas = ref(false)

  const getAreasActive = async () => {
    loadingAreas.value = true
    areas.value = await AreaService.getActivated()
    loadingAreas.value = false
  }

  const areasOptions = computed(() => {
    return areas.value.map(area => {
      return {
        value: Number(area.id),
        text: area.name
      }
    })
  })

  return { areas, getAreasActive, areasOptions, loadingAreas }
}
